import { Box } from '@mui/material';
import { AttributeProps } from '../../../../../constants/fieldsManagementConsts';
import { useCallback, useState } from 'react';
import PicklistTable from './PickistTable';
import { IconButton } from '@sweep-io/sweep-design';
import { Plus } from '@sweep-io/sweep-design/dist/icons';
import { PicklistValue } from 'ts-force';

const AttributePicklist = ({ setFieldValue, isLeadingField, values }: AttributeProps) => {
  const [counter, setCounter] = useState(2);

  const getInitialValue = useCallback((): PicklistValue => {
    const res: PicklistValue = {
      active: true,
      defaultValue: false,
      value: `Value ${counter}`,
      label: `Value ${counter}`,
    };
    setCounter(counter + 1);
    return res;
  }, [counter]);

  const handleChange = useCallback(
    (updatedValueSet: PicklistValue[]) => {
      setFieldValue('sfField.picklistValues', updatedValueSet);
    },
    [setFieldValue],
  );

  const addRow = () => {
    let updated = values?.sfField?.picklistValues;
    updated = updated ? updated.concat([getInitialValue()]) : [getInitialValue()];
    setFieldValue('sfField.picklistValues', updated);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="8px"
      sx={{
        overflowX: 'hidden',
      }}
    >
      <Box
        sx={{
          overflowY: 'auto',
        }}
      >
        <PicklistTable
          valueSet={values.sfField?.picklistValues ?? []}
          handleChange={handleChange}
          isLeadingField={isLeadingField}
        />
      </Box>

      {!isLeadingField && (
        <Box flex="0 0 auto">
          <IconButton onClick={addRow} variant="system" size="small">
            <Plus />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default AttributePicklist;
